import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as VmsState from '../../backend/index-vms-state.js';
import * as Cognito from '../../backend/cognito.js';

class MODWizard extends Component {
    state = { accessToken: null };

    componentDidMount = () => {
        Cognito.accessToken().then(token => this.setState(state => ({ ...state, accessToken: token })));
        window.addEventListener('message', e => {
            if (e.data.name === 'plugin/confirmMenuChange') {
                const { dispatch } = this.props;
                dispatch(VmsState.ViewReducer.Actions.confirmMenuChange(e.data.wasConfirmed));
            } else if (e.data.name === 'plugin/requestNewAuthToken') {
                Cognito.accessToken().then(token => {
                    this.sendEvent('plugin/newAuthToken', { token });
                });
            }
        });
    };

    componentDidUpdate(nextProps) {
        const { showConfirmLeaveMessage } = this.props;
        if (nextProps.showConfirmLeaveMessage !== showConfirmLeaveMessage && showConfirmLeaveMessage) {
            this.sendEvent('plugin/askToConfirmLeave');
        }
    }

    sendEvent = (name, params = {}) => this.getDocument().contentWindow.postMessage({ name, params }, '*');

    getDocument = () => document.getElementById('mod-wizard-frame');

    render() {
        // const baseUrl = config.env === 'prod' ? 'https://ondisplay-wizard.locuslabs.com' : 'https://apps.locuslabs.com/modWizard'
        const baseUrl = import.meta.env.VITE_MOD_WIZARD_URL ? import.meta.env.VITE_MOD_WIZARD_URL : 'https://apps.locuslabs.com/modWizard';
        return this.state.accessToken ? (
            <iframe
                title="Maps On Digital Display Wizard"
                id="mod-wizard-frame"
                src={`${baseUrl}/?auth=${this.state.accessToken}&accountId=${this.props.accountId}`}
                style={{ width: '100%', height: '100%', border: 'none' }}
            />
        ) : null;
    }
}

const mapStateToProps = state => {
    const menuItemToBeConfirmed = VmsState.ViewReducer.Selectors.getMenuItemToBeConfirmed(state) || null;
    const showConfirmLeaveMessage = menuItemToBeConfirmed !== null;
    const accountId = VmsState.SessionReducer.Selectors.getAccountId(state);

    return { showConfirmLeaveMessage, accountId };
};

export default connect(mapStateToProps)(MODWizard);
